import React, { Component } from "react";
import { Card } from "react-bootstrap";
import Select from 'react-select';
import AscModal from "../Elements/Modal/Modal";
import InlineForm from "../Elements/FromGroup/InlineForm";
import moment from "moment";
import SetDataWithSpeechBubble from "../Elements/AscElements/SetDataWithSpeechBubble";
import "./RecordVocAnalysisModal.css";

// VoCカテゴリ選択数の制限
const MAX_VOC_CATEGORIES = 10; // 最大選択数

export default class RecordVocAnalysisModal extends Component {
    getFilterData = (param) => {
        if (!this.props.state || !this.props.state.hidden_filtered) return "";
        const found = this.props.state.hidden_filtered.find(row => row.id === param);
        return found ? found.value : "";
    }

    formatDateRange = () => {
        const start = this.getFilterData("answer_datetime");
        const end = this.getFilterData("end_datetime");
        if (!start && !end) return "-";
        const s = start ? moment(start).format(this.props.langText.Body.DateFormatJapanese) : "-";
        const e = end ? moment(end).format(this.props.langText.Body.DateFormatJapanese) : "-";
        return `${s} ~ ${e}`;
    }

    formatKeywords = () => {
        const keywords = this.getFilterData("keyword");
        if (Array.isArray(keywords) && keywords.length > 0) {
            return keywords.join("、");
        }
        return "-";
    }

    formatInOut = () => {
        const v = this.getFilterData("inout_type");
        if (v === "in") return this.props.langText.Body.Incoming;
        if (v === "out") return this.props.langText.Body.Outgoing;
        return this.props.langText.Body.AllType;
    }

    render() {
        const { state } = this.props;
        const eligibleCount = state && typeof state.voc_eligible_count === 'number' ? state.voc_eligible_count : 0;

        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Card variant="info">
                    <Card.Body>
                        <div style={{ fontWeight: "bold", marginBottom: 10, marginTop: 15}}>
                            {this.props.langText.Body.VocAnalysisCreateDescription}
                        </div>
                        <div style={{ fontSize: "12px", marginTop: 10}}>
                            {this.props.langText.Body.VocAnalysisCreateNoticeHeavy}
                        </div>
                        {/* 進捗文はダイアログで通知するため、ここでの常時表示は廃止 */}

                        <InlineForm
                            key="voc-count"
                            controlId="voc-count"
                            label={this.props.langText.Body.VocEligibleCallCount}
                            readOnly
                        >
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ fontSize: '12px', marginBottom: '4px' }}>
                                    {this.props.langText.Body.VocEligibleCallNote}
                                </div>
                                <div>{eligibleCount.toLocaleString()}件</div>
                            </div>
                        </InlineForm>

                        <InlineForm
                            key="voc-datetime"
                            controlId="voc-datetime"
                            label={this.props.langText.Body.DateTime}
                            readOnly
                        >
                            <div>{this.formatDateRange()}</div>
                        </InlineForm>

                        <InlineForm
                            key="voc-keyword"
                            controlId="voc-keyword"
                            label={this.props.langText.Body.Word}
                            readOnly
                        >
                            <div>{this.formatKeywords()}</div>
                        </InlineForm>

                        <InlineForm
                            key="voc-dest"
                            controlId="voc-dest"
                            label={this.props.langText.Body.DestTelNumber}
                            readOnly
                        >
                            <div>{this.getFilterData("dest_tel_number") || "-"}</div>
                        </InlineForm>

                        <InlineForm
                            key="voc-inout"
                            controlId="voc-inout"
                            label={this.props.langText.Body.InOutType}
                            readOnly
                        >
                            <div>{this.formatInOut()}</div>
                        </InlineForm>

                        {/* VoCカテゴリ選択 */}
                        <InlineForm
                            key="voc-categories"
                            controlId="voc-categories"
                            label={
                                <SetDataWithSpeechBubble
                                    displayData={this.props.langText.Body.VocAnalysisCategory}
                                    speechBubbleData={this.props.langText.Message.VocCategorySelectionHint}
                                    infoIconDisplayFlag={true}
                                    infoIconType={null}
                                    infoIconClassName="modal-info-icon"
                                    infoIconColor="silver"
                                    infoIconSize="lg"
                                    tooltipClassName="voc-category-tooltip-wide"
                                />
                            }
                            labelCol={12}
                            formCol={12}
                        >
                            <Select
                                key={`voc-select-${this.props.vocCategoryOptions ? this.props.vocCategoryOptions.length : 0}`}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                isClearable={true}
                                getOptionValue={(option) => option.value}
                                getOptionLabel={(option) => option.label}
                                isOptionDisabled={(option) => {
                                    const selectedCount = (this.props.selectedVocCategories && this.props.selectedVocCategories.length) || 0;

                                    // 最大選択数未満の場合は全て有効
                                    if (selectedCount < MAX_VOC_CATEGORIES) return false;
                                    // 最大選択数に達している場合、既に選択されているオプション以外を無効化
                                    const isAlreadySelected = this.props.selectedVocCategories && this.props.selectedVocCategories.some(cat => cat.voc_categories_uuid === option.value);
                                    return !isAlreadySelected;
                                }}
                                options={this.props.vocCategoryOptions ? this.props.vocCategoryOptions.map(cat => ({
                                    value: cat.voc_categories_uuid,
                                    label: cat.category_name,
                                    data: cat
                                })) : []}
                                value={this.props.selectedVocCategories ? this.props.selectedVocCategories.map(cat => ({
                                    value: cat.voc_categories_uuid,
                                    label: cat.category_name,
                                    data: cat
                                })) : []}
                                onChange={(selectedOptions) => {
                                    if (!selectedOptions) {
                                        // すべてクリアされた場合
                                        this.props.onVocCategoryToggle([]);
                                    } else if (Array.isArray(selectedOptions) && selectedOptions.length <= MAX_VOC_CATEGORIES) {
                                        // 最大選択数以内の選択
                                        this.props.onVocCategoryToggle(selectedOptions.map(opt => opt.data));
                                    } else if (Array.isArray(selectedOptions) && selectedOptions.length > MAX_VOC_CATEGORIES) {
                                        // 最大選択数を超える選択（念のため）
                                        alert(`VoCカテゴリは最大${MAX_VOC_CATEGORIES}個まで選択できます`);
                                        // 最大選択数までを保持
                                        this.props.onVocCategoryToggle(selectedOptions.slice(0, MAX_VOC_CATEGORIES).map(opt => opt.data));
                                    }
                                }}
                                placeholder={this.props.langText.Message.NoVocCategoriesAvailable || "VoCカテゴリを選択してください"}
                                noOptionsMessage={() => this.props.langText.Message.NoVocCategoriesAvailable || "VoCカテゴリが登録されていません"}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '38px'
                                    })
                                }}
                            />
                            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                                選択数: {this.props.selectedVocCategories ? this.props.selectedVocCategories.length : 0} / {MAX_VOC_CATEGORIES}
                            </div>
                        </InlineForm>

                        {/* メモ入力 */}
                        <InlineForm
                            key="voc-memo"
                            controlId="voc-memo"
                            label={this.props.langText.Body.Memo}
                        >
                            <textarea
                                className="form-control"
                                rows={3}
                                maxLength={2048}
                                value={this.props.state.voc_report_memo || ''}
                                onChange={(e) => {
                                    if (this.props.onVocReportMemoChange) {
                                        this.props.onVocReportMemoChange(e.target.value);
                                    } else {
                                        this.props.propSetState({ voc_report_memo: e.target.value });
                                    }
                                }}
                                placeholder={this.props.langText.Message.Placeholder_InputMemo}
                            />
                        </InlineForm>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

